import debounce from "lodash/debounce";
import { Download } from "lucide-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import {
  fetchPricingFileAPI,
  fileIsExistOrNot,
  uploadPricingFileAPI,
} from "../../api/pricingFiles";
import {
  Block,
  Button,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
  PreviewCard,
  TooltipComponent,
} from "../../components/Component";
import DateRangePicker from "../../components/DateRangePicker";
import Content from "../../layout/content/Content";
import DeleteModal from "./DeletePricingFileModal";
import OverwriteUploadFileModal from "./OverwriteUploadFileModal";
import { useCookies } from "react-cookie";

const Index = () => {
  const [files, setFiles] = useState([]);
  const [data, setData] = useState([]);
  // const [tablesm, updateTableSm] = useState(false);
  const tablesm = false;
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  // const [actionText, setActionText] = useState("");
  const actionText = "";
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [sort, setSortState] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadButtonLoading, setUploadButtonLoading] = useState(false);
  const [sortType, setSortType] = useState("ASC");
  const [modal, setModal] = useState(false);
  const [mutation, setMutation] = useState({});
  const [metadata, setMetadata] = useState({});
  const [overwriteModal, setOverwriteModal] = useState(false);
  const [selectTableItem, setSelectTableItem] = useState(null);
  const [existingFilesCount, setExistingFilesCount] = useState(0);
  const [cookies, setCookie] = useCookies(["pricingFilePetro"]);
  const savedPetro = cookies.pricingFilePetro;

  const {
    control,
    watch,
    register,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      rangeStart: "",
      rangeEnd: "",
      selectPetro: savedPetro ?? "loves",
    },
  });
  

  const selectedPetro = watch("selectPetro");
  const rangeStart = watch("rangeStart");
  const rangeEnd = watch("rangeEnd");

  const handleSetMutation = () => {
    setMutation({});
  };

  useEffect(() => {
    if (selectedPetro) {
      setCookie("pricingFilePetro", selectedPetro, {
        path: "/",
        maxAge: 60 * 60 * 24 * 30,
        sameSite: "lax",
      });
    }
  }, [selectedPetro, setCookie]);

  const handleDropChange = async (acceptedFiles) => {
    try {
      const isValidFile = acceptedFiles.every((file) =>
        ["xlsx", "xls", "csv"].includes(
          file.name.split(".").pop().toLowerCase()
        )
      );

      if (!isValidFile) {
        toast.error("Please upload a valid Excel file (.xls or .xlsx, .csv).", {
          position: "top-center",
        });
        setFiles([]);
        return;
      }

      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    } catch (error) {
      toast.error(error?.response?.data?.message || "server error", {
        position: "top-center",
      });
    }
  };
  const [DeleteDetails, setDeleteDetails] = useState({
    id: null,
  });
  const handelModal = (value) => {
    setModal(value);
  };
  const handleUploadFileModal = (value) => {
    setOverwriteModal(value);
  };

  const overwriteModalDetails = {
    files: files,
    setUploadFilesForModal: (value) => {
      setFiles(value);
    },
  };
  const handleDelete = (id) => {
    try {
      setModal(true);
      setDeleteDetails({
        id: id,
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleCancel = () => {
    setFiles([]);
  };

  const handleUpload = async () => {
    setUploadButtonLoading(true);
    try {
      if (files.length === 0) {
        toast.error("Please select a file to upload.", {
          position: "top-center",
        });
        return;
      }
      const formData = new FormData();
      // Append each file to the FormData object
      for (let i = 0; i < files.length; i++) {
        formData.append("pricing-files", files[i]);
      }

      // check the file is exist or not
      const isExist = await fileIsExistOrNot(formData);
      if (!isExist.data.status) {
        setExistingFilesCount(isExist.data.data);
        handleUploadFileModal(true);
        return;
      }

      const response = await uploadPricingFileAPI(formData);

      toast.success(response?.data?.message, {
        position: "top-center",
      });
      setFiles([]);
      handleSetMutation({});
    } catch (error) {
      toast.error(error?.response?.data?.message || "server error", {
        position: "top-center",
      });
      setFiles([]);
    } finally {
      setUploadButtonLoading(false);
    }
  };

  // Sorting data
  const sortFunc = (params) => {
    if (params === "asc") {
      setSortType("asc");
    } else if (params === "dsc") {
      setSortType("desc");
    }
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function which fires on applying selected action
  const onActionClick = (e) => {
    if (actionText === "suspend") {
      let newData = data?.map((item) => {
        if (item.checked === true) item.status = "Suspend";
        return item;
      });
      setData([...newData]);
    } else if (actionText === "delete") {
      let newData;
      newData = data.filter((item) => item.checked !== true);
      setData([...newData]);
    }
  };

  // function to toggle the search option
  const toggle = () => setonSearch(!onSearch);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    setLoading(true);
    const debouncedHandleUserList = debounce(async () => {
      try {
        const response = await fetchPricingFileAPI({
          page: currentPage,
          limit: itemPerPage,
          order: sortType,
          search: onSearchText,
          rangeStart,
          rangeEnd,
          petro: selectedPetro,
        });
        setData(response?.data?.data?.data);
        setMetadata(response?.data?.data?.metadata);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }, 300);

    debouncedHandleUserList();

    return () => {
      debouncedHandleUserList.cancel();
    };
  }, [
    currentPage,
    itemPerPage,
    sortType,
    onSearchText,
    mutation,
    actionText,
    // watch,
    rangeStart,
    rangeEnd,
    selectedPetro,
  ]);

  return (
    <Content>
      <Block size="lg">
        <PreviewCard>
          <Row className="g-4">
            <Col sm="12">
              <label className="form-label">Pricing File</label>
              <Dropzone onDrop={(acceptedFiles) => handleDropChange(acceptedFiles, setFiles)} maxFiles={1000}>
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()} className="dropzone upload-zone dz-clickable">
                      <input {...getInputProps()} accept=".xls,.xlsx,.csv" />
                      {files?.length === 0 && (
                        <div className="dz-message">
                          <span className="dz-message-text">Drag and drop Pricing File here or click to upload</span>
                          <span className="dz-message-or">or</span>
                          <Button color="primary">Choose File</Button>
                        </div>
                      )}

                      {files?.map((file, index) =>
                        files?.length === 1
                          ? index === 0 && (
                              <div
                                key={file.name}
                                className="dz-preview dz-processing dz-image-preview dz-error dz-complete w-100 h-100 d-flex justify-content-center align-items-center"
                              >
                                <div>{file.name}</div>
                              </div>
                            )
                          : index === 0 && (
                              <div
                                key={file.name}
                                className="dz-preview dz-processing dz-image-preview dz-error dz-complete w-100 h-100 d-flex justify-content-center align-items-center"
                              >
                                <div>{file.name}, ...</div>
                              </div>
                            ),
                      )}
                    </div>
                  </section>
                )}
              </Dropzone>
            </Col>
            <Col sm="12" md="6" lg="6">
              <div className=" d-flex justify-content-start align-items-center gap-2">
                <a
                  href={process.env.REACT_APP_BASE_URL + "public/sample-file-upload/TA_PETRO_PRICES_CP_MAVERIK_CP_3-24-2026-sample-file.xls"}
                  target="_blank"
                  rel="noreferrer"
                >
                  Download Sample Pricing File &nbsp;
                  <Download size={16} className="pb-1" />
                </a>
              </div>
            </Col>
            {files?.length > 0 && (
              <Col sm="12" md="6" lg="6">
                <div className=" d-flex justify-content-end align-items-center gap-2">
                  <Button disabled={uploadButtonLoading} onClick={handleCancel}>
                    Cancel
                  </Button>
                  <Button disabled={uploadButtonLoading} color="primary" onClick={handleUpload}>
                    {uploadButtonLoading ? <Spinner size="sm" /> : "Upload"}
                  </Button>
                </div>
              </Col>
            )}
          </Row>
        </PreviewCard>
      </Block>
      <Block className=" px-2 px-md-0">
        <DataTable className="card-stretch">
          <div className="card-inner position-relative card-tools-toggle">
            <div className="card-title-group">
              <div className="card-tools">
                <div className="form-inline flex-nowrap gx-3">
                  <div className="btn-wrap">
                    <span className="d-none">
                      <Button
                        color="light"
                        outline
                        disabled={actionText !== "" ? false : true}
                        className="btn-dim btn-icon"
                        onClick={(e) => onActionClick(e)}
                      >
                        <Icon name="arrow-right"></Icon>
                      </Button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="card-tools me-n1 w-100 ">
                <ul className="btn-toolbar gx-1 justify-content-end justify-content-md-between d-block d-md-none">
                  <DateRangePicker
                    control={control}
                    setValue={setValue}
                    rangeStart={rangeStart}
                    rangeEnd={rangeEnd}
                    errors={errors}
                    startLabel={"rangeStart"}
                    endLabel={"rangeEnd"}
                    isButton={true}
                    // namePrefix="range1"
                  />
                </ul>
                <ul className="btn-toolbar gx-1 justify-content-end justify-content-md-between">
                  <div className="d-none d-md-flex align-items-center">
                    <div className="">
                      <label className="form-label">Station Type</label>
                      <ul className="g-3 align-center" style={{ width: "max-content" }}>
                        <li>
                          <div className="custom-control custom-radio custom-control-pro no-control">
                            <input
                              type="radio"
                              className="custom-control-input"
                              {...register("selectPetro", {
                                required: "Please select a Petro option",
                              })}
                              value="loves"
                              id="petroLoves"
                            />
                            <label className="custom-control-label" htmlFor="petroLoves">
                              Loves
                            </label>
                          </div>
                        </li>
                        <li>
                          <div className="custom-control custom-radio custom-control-pro no-control">
                            <input
                              type="radio"
                              className="custom-control-input"
                              {...register("selectPetro", {
                                required: "Please select a Petro option",
                              })}
                              value="ta_petro"
                              id="petroTA"
                            />
                            <label className="custom-control-label" htmlFor="petroTA">
                              TA Petro
                            </label>
                          </div>
                        </li>
                      </ul>
                      {errors.selectPetro && <span className="custom-invalid">{errors.selectPetro.message}</span>}
                    </div>
                    <div className="">
                      <label className="form-label ps-2">Filter Date</label>
                      <div>
                        <DateRangePicker
                          control={control}
                          setValue={setValue}
                          rangeStart={rangeStart}
                          rangeEnd={rangeEnd}
                          errors={errors}
                          startLabel={"rangeStart"}
                          endLabel={"rangeEnd"}
                          isButton={true}
                          //namePrefix="range1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="btn-toolbar gx-1">
                    <li>
                      <a
                        href="#search"
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle();
                        }}
                        className="btn btn-icon search-toggle toggle-search"
                      >
                        <Icon name="search"></Icon>
                      </a>
                    </li>
                    <li>
                      <div className="toggle-wrap">
                        <UncontrolledDropdown>
                          <DropdownToggle color="tranparent" className={`btn-icon btn-trigger dropdown-toggle ${tablesm ? "active" : ""}`}>
                            <Icon name="setting"></Icon>
                          </DropdownToggle>
                          <DropdownMenu end className="dropdown-menu-xs">
                            <ul className="link-check">
                              <li>
                                <span>Show</span>
                              </li>
                              <li className={itemPerPage === 10 ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setItemPerPage(10);
                                  }}
                                >
                                  10
                                </DropdownItem>
                              </li>
                              <li className={itemPerPage === 20 ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setItemPerPage(20);
                                  }}
                                >
                                  20
                                </DropdownItem>
                              </li>
                              <li className={itemPerPage === 50 ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setItemPerPage(50);
                                  }}
                                >
                                  50
                                </DropdownItem>
                              </li>
                            </ul>
                            <ul className="link-check">
                              <li>
                                <span>Order</span>
                              </li>
                              <li className={sort === "dsc" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSortState("dsc");
                                    sortFunc("dsc");
                                  }}
                                >
                                  DESC
                                </DropdownItem>
                              </li>
                              <li className={sort === "asc" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSortState("asc");
                                    sortFunc("asc");
                                  }}
                                >
                                  ASC
                                </DropdownItem>
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
            <div className={`card-search search-wrap ${!onSearch && "active"}`}>
              <div className="card-body">
                <div className="search-content">
                  <Button
                    className="search-back btn-icon toggle-search active"
                    onClick={() => {
                      setSearchText("");
                      toggle();
                    }}
                  >
                    <Icon name="arrow-left"></Icon>
                  </Button>
                  <input
                    type="text"
                    className="border-transparent form-focus-none form-control"
                    placeholder="Search by pricing file name"
                    value={onSearchText}
                    onChange={(e) => onFilterChange(e)}
                  />
                  <Button className="search-submit btn-icon">
                    <Icon name="search"></Icon>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <DataTableBody>
            <DataTableHead>
              <DataTableRow size="lg">
                <span className="sub-text d-none d-lg-block">File Name</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">Date</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">Uploaded By</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">Uploaded Date</span>
              </DataTableRow>
              <DataTableRow className="nk-tb-col-tools text-end" size="lg"></DataTableRow>
            </DataTableHead>
            {/*Head*/}
            {loading ? (
              <tr>
                <td colSpan="100%">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "100px", width: "100%" }} // Full height and width
                  >
                    <Spinner color="primary" />
                  </div>
                </td>
              </tr>
            ) : (
              <>
                {data?.length > 0
                  ? data?.map((item) => {
                      return (
                        <React.Fragment key={item.id}>
                          <DataTableItem className=" border-top expanded-view">
                            <DataTableRow size="lg">
                              <span
                                className="d-block d-lg-none"
                                onClick={() => {
                                  if (selectTableItem === item.id) {
                                    setSelectTableItem(null);
                                  } else {
                                    setSelectTableItem(item.id);
                                  }
                                }}
                              >
                                {item?.original_filename?.length > 35 ? item?.original_filename?.substring(0, 35) + "..." : item?.original_filename}
                              </span>
                              <span
                                className="d-none d-lg-block"
                                onClick={() => {
                                  if (selectTableItem === item.id) {
                                    setSelectTableItem(null);
                                  } else {
                                    setSelectTableItem(item.id);
                                  }
                                }}
                              >
                                {item?.original_filename}
                              </span>
                            </DataTableRow>
                            <DataTableRow size="lg" className=" overflow-hidden">
                              <span>{moment(item.filedate).format("MM-DD-YYYY")}</span>
                            </DataTableRow>
                            <DataTableRow size="lg">
                              <span>{item.uploaded_name}</span>
                            </DataTableRow>
                            <DataTableRow size="lg">
                              <span>{moment(item.createdAt).format("MM-DD-YYYY")}</span>
                            </DataTableRow>
                            <DataTableRow className="nk-tb-col-tools" size="lg">
                              <ul className="nk-tb-actions gx-1">
                                <li className="nk-tb-action-hidden">
                                  <TooltipComponent
                                    tag="a"
                                    containerClassName="btn btn-trigger btn-icon"
                                    id={"download" + item.id}
                                    icon="download"
                                    direction="top"
                                    text="Download"
                                    href={
                                      process.env.REACT_APP_BASE_URL +
                                      `public/uploads/${savedPetro.toLowerCase() == "loves" ? "loves_pricing_files" : "pricing_files"}/` +
                                      item.filename
                                    }
                                    download={item.original_filename}
                                    target="_blank"
                                  />
                                </li>
                                <li
                                  className="nk-tb-action-hidden"
                                  onClick={() => {
                                    handleDelete(item.id);
                                  }}
                                >
                                  <TooltipComponent
                                    tag="a"
                                    containerClassName="btn btn-trigger btn-icon"
                                    id={"trash" + item.id}
                                    icon="trash"
                                    direction="top"
                                    text="Delete"
                                  />
                                </li>
                                <li>
                                  <UncontrolledDropdown>
                                    <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger d-md-none">
                                      <Icon name="more-h"></Icon>
                                    </DropdownToggle>
                                    <DropdownMenu end>
                                      <ul className="link-list-opt no-bdr">
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href={process.env.REACT_APP_BASE_URL + "public/uploads/pricing-files/" + item.filename}
                                            download={item.original_filename}
                                          >
                                            <Icon name="download"></Icon>
                                            <span>Download</span>
                                          </DropdownItem>
                                        </li>
                                        <li onClick={() => {}}>
                                          <DropdownItem
                                            tag="a"
                                            href="#trash"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              handleDelete(item.id);
                                            }}
                                          >
                                            <Icon name="trash"></Icon>
                                            <span>Delete</span>
                                          </DropdownItem>
                                        </li>
                                      </ul>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </li>
                              </ul>
                            </DataTableRow>
                          </DataTableItem>
                          {
                            <div className="d-lg-none nk-tb-item">
                              <div className="nk-tb-col tb-col-xs">
                                <div className="d-flex g-1 flex-wrap fs-14px">
                                  <span className="sub-text">File Name: &nbsp;</span>
                                  <span className="fw-bold">{item?.original_filename?.substring(0, 20)}</span>
                                  <span className="fw-bold mb-1">{item?.original_filename?.substring(30, 60)}</span>
                                </div>
                                <div className="d-flex g-1 fs-14px">
                                  <span className="sub-text">Date:&nbsp; </span>
                                  <span className="fw-bold">{moment(item.filedate).format("MM-DD-YYYY")}</span>
                                </div>{" "}
                                <div className="d-flex g-1 fs-14px">
                                  <span className="sub-text">Uploaded By:&nbsp;</span>
                                  <span className="fw-bold">{item.uploaded_name}</span>
                                </div>
                                <div className="d-flex g-1 fs-14px">
                                  <span className="sub-text">Uploaded Date:&nbsp;</span>
                                  <span className="fw-bold">{moment(item.createdAt).format("MM-DD-YYYY")}</span>
                                </div>
                              </div>
                              <div className="nk-tb-col tb-col-xs">
                                <ul className="nk-tb-actions">
                                  <li>
                                    <UncontrolledDropdown>
                                      <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger d-lg-none">
                                        <Icon name="more-h"></Icon>
                                      </DropdownToggle>
                                      <DropdownMenu end>
                                        <ul className="link-list-opt no-bdr">
                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href={process.env.REACT_APP_BASE_URL + "public/uploads/pricing-files/" + item.filename}
                                              download={item.original_filename}
                                            >
                                              <Icon name="download"></Icon>
                                              <span>Download</span>
                                            </DropdownItem>
                                          </li>
                                          <li onClick={() => {}}>
                                            <DropdownItem
                                              tag="a"
                                              href="#trash"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                handleDelete(item.id);
                                              }}
                                            >
                                              <Icon name="trash"></Icon>
                                              <span>Delete</span>
                                            </DropdownItem>
                                          </li>
                                        </ul>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          }
                        </React.Fragment>
                      );
                    })
                  : null}
              </>
            )}
          </DataTableBody>
          <div className="card-inner">
            {data?.length > 0 ? (
              <PaginationComponent itemPerPage={itemPerPage} totalItems={metadata?.totalRecords} paginate={paginate} currentPage={currentPage} />
            ) : (
              <div className="text-center">
                <span className="text-silent">No data found</span>
              </div>
            )}
          </div>
        </DataTable>
      </Block>
      <DeleteModal handelModal={handelModal} DeleteDetails={DeleteDetails} modal={modal} handleSetMutation={handleSetMutation} />
      <OverwriteUploadFileModal
        handelModal={handleUploadFileModal}
        fileDetails={overwriteModalDetails}
        existingFilesCount={existingFilesCount}
        modal={overwriteModal}
        handleSetMutation={handleSetMutation}
      />
    </Content>
  );
};

export default Index;
